const TransportationFormLayout = [
    {
        "groupId": 1,
        "label": "Transportation",
        "fields": [
            {
                "name": "TRANSPORTATIONMODE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Mode",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false,
                "isLabelChanged": true,

            },
            {
                "name": "R_EQUIPMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Truck",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "FMTRUCKREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Truck Ref.#",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_CARRIER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Carrier",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_DRIVER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Driver",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "FMDRIVERREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Driver Ref.#",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_AGENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Agent",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "R_TRANSPORTCARRIER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trans Carrier:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "EQUIPMENTTYPE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Equipment",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "TRUCKREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference #",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CONTAINER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Container #",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "R_TRAILER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trailer",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "FMTRAILERRREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trailer Ref.#",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "EQUIPMENTINTERCHANGEREPORT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trailer #/EIR",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 2,
        "label": "Dock/Yard Information",
        "fields": [
            {
                "name": "DELIVERYPICKUPDEPARTDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fenced are",
                "type": "datetime",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKARRIVALDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock - Start",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "TRUCKDEPARTDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock - End",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "TRANSPORTATIONYARDLEAVEDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Yard - Leave",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "R_TRANSPORTATIONWAREHOUSE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Warehouse",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "R_TRANSPORTATIONLOCATION",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Location",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "DELIVERYPICKUPCOMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Product COD Information",
        "fields": [
            {
                "name": "R_CODPAYOR",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Payor",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "R_CODPAYEE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Payee",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "CODPAYMETHOD",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pay Method",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false,
            },
            {
                "name": "CODAMOUNT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Amount",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "CODAMOUNTCOLLECTED",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Collected",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "CODCOLLECTIONDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "CODCOMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Shipment",
        "fields": [
            {
                "name": "SHIPMENTPLANNEDDATETIMEFROM",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Planned From",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "SHIPMENTPLANNEDDATETIMETO",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Planned To",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "DELIVEREDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivered",
                "type": "datetime",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
           
        ]
    },
    {
        "groupId": 5,
        "label": "Freight Management Interface",
        "fields": [
            {
                "name": "TRANSFERTODISPATCH",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "FM Transfer",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false,
            },
            {
                "name": "R_FMTRANSACTIONPROFILE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "FM Profile",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "ignoredblocalization": true
            }
        ]
    },
    {
        "groupId":6,
        "label": "Shipment Tracking",
        "fields": [
            {
                "name": "ShipmentTrackingNumber",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Tracking Number",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
        ]
    }
];

export default TransportationFormLayout;
